import Command from '@ckeditor/ckeditor5-core/src/command';

export default class MediaNotificationCommand extends Command {
  refresh() {
    // Listens when entire document is selected via CTRL + A or Select ALL button
    const selectAll = this.editor.commands.get( 'selectAll' );
    selectAll.on( 'execute', () => {
      this.selected = !this.selected;
      this.enableButton();
    } );
  }

  enableButton() {
    const editor = this.editor;
    const selection = editor.model.document.selection;
    const range = selection.getFirstRange();
    for (const item of range.getItems()) {
      if (item.name === 'img' || item.name === 'insertimage') {
        editor.fire( 'mediaPropertiesNotification', true );
      }
        
    }
  }
}
